/* global window */
import { urls as locationsUrls } from '../reducers/locations';
import { add } from 'Helpers/recentLocations';
import { locationByIdSelector } from 'Selectors/location';
import { supportLocalStorage } from 'Helpers/localStorage';

const selectLocation = data => {
    add(data);
    return {
        type: 'SELECT_LOCATION',
        data
    };
};

const sortAddressComponents = address => address.sort((a, b) => a.order - b.order);

const setSiLocation = loc => dispatch => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('siCity', JSON.stringify(loc));
    }
    return dispatch({ type: 'SET_SI_LOCATION', payload: loc });
};

const removeSiLocation = () => dispatch => {
    if (supportLocalStorage()) {
        window.localStorage.removeItem('siCity');
    }
    return dispatch({ type: 'REMOVE_SI_LOCATION' });
};

const setCitySiLocation = (location, dispatch) => {
    const city = location.addressComponents.find(address => address.type === 'CITY');

    if (city) {
        dispatch(setSiLocation({ sphareName: city.name, sphareId: city.id }));
    }
    else {
        dispatch(setSiLocation({ sphareName: location.name, sphareId: location.id }));
    }
};

/**
 * Sets the given location object as the selected Object in the redux store after properly sanetizing it
 * PS: this will unset the gps location(gps.currentLocation flag) in the store
 * @param {*} location- The locationObject
 */
const updateLocation = location => (dispatch, getState, { get }) => {
    const loc = {
        ...location,
        ...(locationByIdSelector(getState())(location.id) || {})
    };

    if (loc && loc.addressComponents) {
        const sorted = {
            ...loc,
            addressComponents: sortAddressComponents(loc.addressComponents)
        };

        setCitySiLocation(sorted, dispatch);

        dispatch(selectLocation(sorted));
        return Promise.resolve();
    }

    return dispatch(get(locationsUrls.getLocation(location.id), 'LOCATIONS')).then(res => {
        if (res.ok) {
            const sorted = {
                ...loc, ...res.data.data,
                addressComponents: sortAddressComponents(res.data.data.addressComponents)
            };

            setCitySiLocation(sorted, dispatch);

            dispatch(selectLocation(sorted));
        }
    });
};

const resetLocation = () => (dispatch, getState) => {
    const { locations: { startingLocation, elements }} = getState();

    return dispatch(selectLocation(elements[startingLocation]));
};

export { updateLocation, resetLocation, setSiLocation, removeSiLocation };
export default selectLocation;
